import { useQuery } from "@tanstack/react-query";
import { instance } from "../../axios.config";

export const useHeaderHome = () => {
  return useQuery({
    queryKey: ["headerHome"],
    queryFn: async () => {
      const { data } = await instance.get("header/home");
      return data;
    },
  });
};

export const useBlogHeader = (params) => {
  return useQuery({
    queryKey: ["blogHeader", params],
    queryFn: async () => {
      const { data } = await instance.get("header/blog", { params });
      return data;
    },
  });
};

export const useAboutHeader = (params) => {
  return useQuery({
    queryKey: ["aboutHeader", params],
    queryFn: async () => {
      const { data } = await instance.get("header/about-us", { params });
      return data;
    },
  });
};
